// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"165":"4735f347","946":"4735f347"}[chunkId] + ".chunk.css";
};